<script>
    let toasts = [];
    function addToast(type, message) {
      const id = Date.now() + Math.random();
      toasts = [...toasts, { id, type, message }];
  
      setTimeout(() => {
        toasts = toasts.filter(t => t.id !== id);
      }, 3000);
    }
    if (typeof window !== 'undefined') {
      window.showToast = addToast;
    }
  
    function closeToast(id) {
      toasts = toasts.filter(t => t.id !== id);
    }
  </script>
  
  <style>
    .toast-container {
      position: fixed;
      top: 1rem;
      right: 1rem;
      z-index: 1080;
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
    }
  </style>
  
  <div class="toast-container" aria-live="assertive" aria-atomic="true">
    {#each toasts as toast (toast.id)}
      <div class={"toast show align-items-center text-bg-" + toast.type + " border-0"} role="alert">
        <div class="d-flex">
          <div class="toast-body">{toast.message}</div>
          <button type="button" class="btn-close btn-close-white me-2 m-auto"
            aria-label="Close"
            on:click={() => closeToast(toast.id)}></button>
        </div>
      </div>
    {/each}
  </div>
  